module.exports = __webpack_public_path__ + "static/Esa-0651c78a501bcf9cc19d05995ae74466.jpg";